<template>
    <div class="not-found">
      <div class="overlay">
        <h1>Cette page est introuvable</h1>
        <p>Et si vous exploriez notre site pour trouver ce que vous recherchez ?</p>
        <div class="btn-group">
          <a href="/" class="btn">RETOUR À LA PAGE D’ACCUEIL</a>
          <a href="/reservation-hotel" class="btn">DÉCOUVRIR NOTRE SÉLECTION</a>
          <a href="/inspirations-voyage-ecoresponsable" class="btn">TROUVEZ L’INSPIRATION</a>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default{
    name: "NotFoundPage"
  }
</script>
  <style scoped>
  .not-found {
    /* background-image: url('/images/404-bg.jpg'); */
    background-image: url("https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/R%C3%A9servation+h%C3%B4tel.webp");
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .overlay {
    /* background: rgba(0, 0, 0, 0.3); */
    padding: 2rem;
    color: white;
    max-width: 600px;
    width: 90%;
  }
  
  h1 {
    font-family: 'Raleway';
    font-size: 2.5rem;
    font-weight: bold;
  }
  
  p {
    font-family: 'Raleway';
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }
  
  .btn-group {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .btn {
    background-color: #2e5b4e;
    color: white;
    font-family: 'Raleway';
    padding: 0.75rem 1.5rem;
    text-decoration: none;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
  </style>  